module.exports = __webpack_public_path__ + "assets/AirbnbCereal-ExtraBold.85f569a3de45dab64d59863d27b7f002.woff";